import { render, staticRenderFns } from "./viewHrflowTable.vue?vue&type=template&id=0f4edc65"
import script from "./viewHrflowTable.vue?vue&type=script&lang=js"
export * from "./viewHrflowTable.vue?vue&type=script&lang=js"
import style0 from "./viewHrflowTable.vue?vue&type=style&index=0&id=0f4edc65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports